/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
    Spinner
} from "reactstrap";

const ReportDataEmpParti = ({ ...props }) => {
    const [dataa, setdataa] = useState([])
    const [load, setload] = useState(true)
    const getdata = async () => {
        const sendData = {
            ParametersId: Number(props.parametersId),
            YearId: Number(props.year),
            MonthId: Number(props.Month),
            ToYearId: Number(props.toyear),
            ToMonthId: Number(props.tomonth),
            UserId: Number(props.UserId)
        }
        ////console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Reporttotaluser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*//console.log(data)*/
                    if (data.length > 0) {
                        setdataa(data)
                        setload(false)
                    }

                    setload(false)
                })

    };

   
    useEffect(() => {
        setload(true)
        getdata()
    }, [props.parametersId, props.UserId, props.generate])


    return (
        <>
            {load ? <Spinner color="success" /> :
                <>
                    {props.emp === 1 &&
                        dataa.length !== 0 ? dataa.map((details, index) =>
                            <td key={index} style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {details.genderTransgender6 >= 0 ? details.genderTransgender6 : 0}
                            </td>) : props.emp === 2 && dataa.length !== 0 ? dataa.map((details, index) =>
                                <td key={index} style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.genderFemale5 >= 0 ? details.genderFemale5 : 0}
                                </td>) : dataa.length !== 0 ? dataa.map((details, index) =>
                                    <td key={index} style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                        {details.casteSc7 >= 0 ? details.casteSc7 : 0}
                                    </td>) : null}




                </>

            }</>
    );
};

export default ReportDataEmpParti;
